import React from 'react'

import BaseSkeleton from 'components/Skeleton/BaseSkeleton'
import { CardSkeletons, HeroSkeleton, SectionSkeleton, SkeletonRoot } from './styled'

export default function CompetitiveIntelligenceSkeleton({ label }) {
    return (
        <SkeletonRoot aria-label={label}>
            <HeroSkeleton>
                <BaseSkeleton height={40} width={190} />
                <BaseSkeleton height={60} width="48%" />
                <BaseSkeleton height={24} width="60%" />
                <BaseSkeleton height={16} width="52%" />
            </HeroSkeleton>
            <SectionSkeleton>
                <BaseSkeleton height={34} width={240} />
                <CardSkeletons>
                {Array.from({ length: 3 }).map((_, index) => (
                    <BaseSkeleton key={index} height={260} width="100%" />
                ))}
                </CardSkeletons>
            </SectionSkeleton>
        </SkeletonRoot>
    )
}
